import { useTranslation } from 'react-i18next';
import {
  FloatingCountryField as HypernovaFloatingCountryField,
  IFloatingCountryFieldProps as IHypernovaFloatingCountryFieldProps,
} from '@coverflex-tech/hypernova';

export interface IFloatingCountryFieldProps
  extends Omit<IHypernovaFloatingCountryFieldProps, 'labels' | 'language'> {}

export function FloatingCountryField({
  id,
  label,
  value,
  error,
  onChange,
  onBlur,
  disabled,
  className,
  menuClassName,
  suggestedCountry,
}: Omit<IHypernovaFloatingCountryFieldProps, 'labels' | 'language'>) {
  const { t, i18n } = useTranslation();

  return (
    <HypernovaFloatingCountryField
      id={id}
      className={className}
      label={label}
      value={value}
      error={error}
      onChange={onChange}
      onBlur={onBlur}
      labels={{
        noResults: t('form.search.no_results'),
      }}
      menuClassName={menuClassName}
      disabled={disabled}
      language={i18n.language}
      suggestedCountry={suggestedCountry}
    />
  );
}
